import * as React from "react";
import { Button, Input } from "react-ui";

import { ThrowClassNameToChildren } from "../../HiddenPanel/ThrowClassNameToChild";
import { emptyRef } from "../../../TypingUtils";
import { isEnterKey } from "../../../../Helpers/KeyboardUtils";
import { Icon } from "../../../Icons/Icon";

import { Item, Item2, MultipleUnitsNavigatorRoot } from "./MultipleUnitsNavigator.styles";

export interface MultipleUnitsNavigatorProps {
    className?: string;
    currentIndex: number;
    onChangeIndex: (nextIndex: number) => void;
    totalCount: number;
    title?: string | undefined;
}

export function MultipleUnitsNavigator(props: MultipleUnitsNavigatorProps): JSX.Element {
    const [inputValue, setInputValue] = React.useState((props.currentIndex + 1).toString());
    const input = React.useRef<Input>(emptyRef);

    React.useEffect(() => {
        setInputValue((props.currentIndex + 1).toString());
    }, [props.currentIndex]);

    const handleChangeInputValue = (nextValue: string) => {
        if (!/^\d*$/.test(nextValue) || Number(nextValue) > props.totalCount) {
            input.current?.blink();
            return;
        }
        setInputValue(nextValue);
    };

    const handleInputKeyDown = (e: React.KeyboardEvent) => {
        const currentValue = Number(inputValue);
        if (isEnterKey(e)) {
            e.preventDefault();
            if (currentValue > 0) {
                props.onChangeIndex(currentValue - 1);
            }
            if (currentValue === 0 || inputValue === "") {
                setInputValue((props.currentIndex + 1).toString());
                input.current?.blur();
            }
        }
    };

    return (
        <MultipleUnitsNavigatorRoot className={props.className}>
            <Item2 as={ThrowClassNameToChildren}>
                <Button
                    use="link"
                    data-tid="previousPage"
                    icon={<Icon name="ArrowCLeftIcon" />}
                    disabled={props.currentIndex <= 0}
                    onClick={() => props.onChangeIndex(props.currentIndex - 1)}>
                    Предыдущий
                </Button>
            </Item2>
            {props.title && <Item data-tid="unitName">{props.title}</Item>}
            <Item>Экземпляр</Item>
            <Item as={ThrowClassNameToChildren}>
                <Input
                    ref={input}
                    value={inputValue}
                    onKeyDown={handleInputKeyDown}
                    onValueChange={handleChangeInputValue}
                    width={64}
                    align="right"
                    selectAllOnFocus
                />
            </Item>
            <Item2 data-tid="totalCount">из {props.totalCount}</Item2>
            <Button
                use="link"
                data-tid="nextPage"
                disabled={props.currentIndex >= props.totalCount - 1}
                onClick={() => props.onChangeIndex(props.currentIndex + 1)}>
                Следующий <Icon name="ArrowCRightIcon" />
            </Button>
        </MultipleUnitsNavigatorRoot>
    );
}
